import "../../css/signin/signin.css";
import "../../css/signin/countries.css";
import "../../css/signin/countries_lazy_load_divs.css";
import { useState, useEffect, useRef, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import {
  handleKeyDown,
  handlePaste,
  handleKeyDownForPasswordInput,
  handlePasteForPasswordInput,
  clickToSubmitButtonWithEnter,
} from "../Inputs/handleKeyDown";
import { AuthContext } from "../SessionChecker/SessionChecker";
import { domain } from "../Links/Links";

function Signin({ theme, setTheme }) {
  const [usernameInputValue, setUsernameInputValue] = useState("");
  const [passwordInputValue, setPasswordInputValue] = useState("");

  const [signinButtonStatus, setSigninButtonStatus] = useState(false);

  const { t } = useTranslation();

  const navigate = useNavigate();

  const [usernameError, setUsernameError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);

  const usernameInputRef = useRef(null);

  const { sessionStatus } = useContext(AuthContext);

  useEffect(() => {
    if (sessionStatus === true) {
      navigate("/");
    }

    if (usernameInputRef.current) {
      usernameInputRef.current.focus();
    }

    clickToSubmitButtonWithEnter();
  }, [sessionStatus]);

  return (
    <div className="signin_main_div">
      <div className="signin_fields_div">
        <div className="signin_title_div">{t("Signin to hiket")}</div>

        <div className="input_div">
          <div>{t("Username")}</div>
          <input
            className={`input dir_ltr ${theme} ${usernameError && "error"}`}
            ref={usernameInputRef}
            onChange={async (e) => {
              setUsernameInputValue(e.target.value);
              setUsernameError(false);
            }}
            onKeyDown={handleKeyDown}
            onPaste={handlePaste}
          ></input>
        </div>

        {usernameError && (
          <div className="input_error_div">
            {t("This username is not available")}
          </div>
        )}

        <div className="input_div">
          <div>{t("Password")}</div>
          <input
            className={`input dir_ltr ${theme} ${passwordError && "error"}`}
            onChange={(e) => {
              setPasswordInputValue(e.target.value);
              setPasswordError(false);
            }}
            onKeyDown={handleKeyDownForPasswordInput}
            onPaste={handlePasteForPasswordInput}
          ></input>
        </div>

        {passwordError && (
          <div className="input_error_div">{t("This password is invalid")}</div>
        )}

        <button
          className={`submit_button fdvvcdfe3 ${theme} ${usernameInputValue && passwordInputValue ? "active" : ""}`}
          onClick={() => {
            if (usernameInputValue && passwordInputValue) {
              setSigninButtonStatus(true);
              const xhr = new XMLHttpRequest();
              xhr.open("POST", domain + "/signin_api/", true);
              xhr.withCredentials = true;
              xhr.onreadystatechange = () => {
                if (xhr.readyState === 4 && xhr.status === 200) {
                  const data = JSON.parse(xhr.responseText);
                  console.log(data);
                  if (data.ok) {
                    console.log("data ok:" + data.ok);
                    window.location.href = "/";
                  } else if (data.username_not_available) {
                    setUsernameError(true);
                  } else if (data.password_is_invalid) {
                    setPasswordError(true);
                  }

                  setSigninButtonStatus(false);
                }
              };
              xhr.setRequestHeader("Content-Type", "application/json");
              const data = JSON.stringify({
                username: usernameInputValue,
                password: passwordInputValue,
                system_name: navigator.userAgent,
                app_name: "Web",
                location: "Iran",
              });
              xhr.send(data);
            }
          }}
        >
          {signinButtonStatus ? (
            <img src="/icons/loading.png" className="rotate"></img>
          ) : (
            t("Signin")
          )}
        </button>
      </div>


      <div className="buttons_div_in_signin1">

        <button
          className={`simple_button ${theme}`}
          onClick={() => navigate("/signup")}
        >
          {t("Signup")}
        </button>

        <button
          className={`simple_button ${theme}`}
          onClick={() => navigate("/password_recovery")}
        >
          {t("Password recovery")}
        </button>

      </div>

      <div className="buttons_div_in_signin2">
        <button
          className={`simple_button fontSize14 ${theme}`}
          onClick={() => navigate("/rules")}
        >
          {t("Rules")}
        </button>
        <button
          className={`simple_button fontSize14 ${theme}`}
          onClick={() => {
            navigate("/languages");
          }}
        >
          {t("Language")}
        </button>
        <button
          className={`simple_button fontSize14 ${theme}`}
          onClick={() => {
            setTheme(theme === "light" ? "night" : "light");
          }}
        >
          {theme === "light" ? t("Night mode") : t("Light mode")}
        </button>
      </div>
    </div>
  );
}

export default Signin;
